const axios = require('axios')
axios.defaults.headers.post['Content-Type'] = 'application/json'
const appConfig = require('../config/config')
const Util = require('util')

var API = function (APP_NAME, NODE_ENV) {
  this.APP_NAME = APP_NAME
  this.NODE_ENV = NODE_ENV
  this.url = appConfig[NODE_ENV].apiUrl
  this.authURL = appConfig[NODE_ENV].authURL
  console.log(NODE_ENV, this.url, this.authURL)
}

API.prototype.test = function (user, pass) {
  // axios // https://services-preprod.bimedia-it.com/pub-locales-ws/api/products/pub-locale
  // http://services-preprod.bimedia-it.com/pub-locales-ws/api/products/pub-locale
  return axios.get(this.url + '/api/products/pub-locale', {
      auth: {
        username: this.user,
        password: this.pass
      }
    }).then(function (response) {
      console.log(response)
    }).catch(function (error) {
      console.log(error)
    })
}

API.prototype.getBase64Media = function (mediaId, token, Callback) {
  try {
    if (!token) {
      throw new Error('No token found for athentication')
    }
    var config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'x-web-token': token
      }
    }
    return axios.post(this.url + '/v2/votre-espace/base-64-media', { mediaId: mediaId }, config)
      .then(function (response) {
        if (response.data.error) {
          return Callback(response.data.error, response.status)
        }
        return Callback(null, response.status, response.data)
      }).catch(function (err) {
        return Callback(err, 403)
      })
  } catch (err) {
    return Callback(err, 403)
  }
}

API.prototype.saveDiffusion = function (userProps, Callback) {
  try {
    if (!userProps || !userProps.token) {
      throw new Error('No token found for athentication')
    }
    var config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'x-web-token': userProps.token
      }
    }
    console.log(JSON.stringify(config, null, 4));
    return axios.post(this.url + '/v2/votre-espace/save-diffusion', userProps, config)
      .then(function (response) {
        if (response.data.error) {
          return Callback(response.data.error, response.status)
        }
        return Callback(null, response.status, response.data)
      }).catch(function (err) {
        return Callback(err, 403)
      })
  } catch (err) {
    return Callback(err, 403)
  }
}

API.prototype.acknowledgeMessages = function (data, Callback) {
  try {
    if (!data || !data.token) {
      throw new Error('No token found for athentication')
    }
    var config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'x-web-token': data.token
      }
    }
    return axios.post(this.url + '/v2/votre-espace/acknowledge-messages', data, config)
      .then(function (response) {        
        if (response.data.error) {
          return Callback(response.data.error, response.status)
        }
        // 
        return Callback(null, response.status, response.data)
      }).catch(function (err) {
        return Callback(err, 403)
      })
  } catch (err) {
    return Callback(err, 403)
  }
}

API.prototype.suppressUserMedia = function (media, userProps, Callback) {
  try {
    var config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'x-web-token': userProps.token
      }
    }
    // 
    return axios.post(this.url + '/v2/votre-espace/suppress-media', {
      mediaId: media.media_id, 
      userProps: userProps
    }, config)
      .then(function (response) {
        if (response.data.error) {
          return Callback(response.data.error, response.status)
        }
        // 
        response.data.body.data.token = userProps.token
        return Callback(null, response.status, response.data.body)
      }).catch(function (err) {
        return Callback(err, 403)
      })
  } catch (err) {
    return Callback(err, 403)
  }
}



API.prototype.saveUserMedia = function (media, token, Callback) {
  try {
    if (!token) {
      throw new InvalidCredentialsError('No token found for authentication')
    }
    var config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'x-web-token': token
      }
    }
    // 
    return axios.post(this.url + '/v2/votre-espace/save-media', media, config)
      .then(function (response) {
        if (!response || !response.data || !response.data.body || !response.data.body.data) {
            var err = new Error('Response is not properly formatted !')
            throw err
        }
        if (response.data.error) {
          return Callback(response.data.error)
        }
        response.data.body.data.token = token
        return Callback(null, response.status, response.data.body)
      }).catch(function (err) {
        return Callback(err, 403)
      })
  } catch (err) {
    return Callback(err, 403)
  }
}


API.prototype.disconnect = function(token, Callback) {
  var url
  var config = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-web-token': token
    }
  }
  return axios.delete(this.url + '/api/auth', config)
    .then(function (response) {
      if (!response || !response.status) {
          var err = new Error('Response is not properly formatted !')
          throw err
      }
      // 
      if (response.status != 204) {
          var err = new Error('Server response error')
          throw err
      }
      // 
      return Callback(null, response.status)
    }).catch(function (err) {
      return Callback(err)
    })
}


API.prototype.verify = function(token, Callback) {
  var config = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-web-token': token
    }
  }
  return axios.get(this.url + '/v2/votre-espace/user', config)
    .then(function (response) {      
      if (!response || !response.data || !response.data.body || !response.data.body.appData) {
          var err = new Error('Response is not properly formatted !')
          throw err
      }
      // 
      if (response.data.error) {
        return Callback(response.data.error)
      }
      // 
      response.data.body.token = token
      var properties = {
        body: response.data.body
      }
      //
      return Callback(null, response.status, properties)
    }).catch(function (err) {
      return Callback(err)
    })
}



API.prototype.authenticate = function(credentials, Callback) {
  var token
  var self = this
  var url
  var config = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
  return axios.get(this.authURL + '/api/auth', {params: credentials}, config)
    .then(function (response) {      
      if (!response || !response.data || !response.data.token) {
          var err = new Error('Response is not properly formatted !')
          throw err
      }
      token = response.data.token
      if (response.data.error) {
        return Callback(response.data.error)
      }
      return self.verify(token, function (err, status, properties) {
        console.log(err, status, properties);
        if (err) {
          return Callback(response.data.error)
        }

        return Callback(null, status, properties)
      })
    }).catch(function (err) {
      return Callback(err)
    })
}

module.exports = function (APP_NAME, NODE_ENV) {
  return new API(APP_NAME, NODE_ENV)
}



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/models/API.js
// module id = 82
// module chunks = 0